import _ from '../util/underscore-wrapper';
import Collection from '../framework/Collection';

/**
 * Wrapper around the more generic {@link src/framework/Collection} that
 * contains Okta-specific logic.
 * @class module:Okta.Collection
 * @extends src/framework/Collection
 */
export default Collection.extend(
  /** @lends module:Okta.Collection.prototype */ {
    /**
     * Is the end point using the legacy "secureJSON" format
     * @type {Function|Boolean}
     */
    secureJSON: false,

    constructor: function () {
      if (_.result(this, 'secureJSON')) {
        this.sync = _.wrap(this.sync, function (sync, method, collection, options) {
          return sync.call(this, method, collection, _.extend({ dataType: 'secureJSON' }, options));
        });
      }
      Collection.apply(this, arguments);
    }
  }
);



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/models/BaseCollection.js